

import React, { memo } from 'react';

import _memoize from 'lodash.memoize';
import { getMinutes } from '@shootsta/format-seconds';
import CommentsContext from '../../../contexts/commentsContext';
import { EditComment, AddComment, AddCommentV2 } from '../components';

const getAddCommentSubtitle = _memoize((time) => () => getMinutes(time));


















function CommentPopover({
  id,
  children,
  commentId,
  onInputFocus,
  sceneId,
  shotId,
  isV2Design,
  onVisibilityChange,
  hideVisibility,
  hideTimestamp
}) {
  const AddCommentComponent = isV2Design ? AddCommentV2 : AddComment;
  const CommentPopoverComponent = commentId ? EditComment : AddCommentComponent;

  return (
    <CommentsContext.Consumer>
      {({
        state: {
          comments,
          commentModalId,
          commentModalProps,
          filterByMetadataFlag,
          isReadOnly,
          canResolveComment,
          resourceOrganisationId,
          resourceOwnerUserId
        },
        actions: {
          deleteComment,
          updateComment,
          createComment,
          createReply,
          editReply,
          deleteReply,
          updateViewers,
          getUserColor,
          closePopover
        } }) => {
        if (!commentModalId || commentModalId !== id) {return children;}

        const { metadata, metadata: { clipCommentTime } = {} } = commentModalProps;
        const getTitle = !commentId && clipCommentTime && getAddCommentSubtitle(clipCommentTime);

        return (
          <CommentPopoverComponent
            onVisibilityChange={onVisibilityChange}
            filterByMetadataFlag={filterByMetadataFlag}
            createComment={createComment}
            createReply={createReply}
            updateComment={updateComment}
            deleteComment={deleteComment}
            editReply={editReply}
            deleteReply={deleteReply}
            updateViewers={updateViewers}
            comment={comments.get(commentId)}
            getUserColor={getUserColor}
            closePopover={closePopover}
            isReadOnly={isReadOnly}
            canResolveComment={canResolveComment}
            resourceOrganisationId={resourceOrganisationId}
            getTitle={getTitle}
            resourceOwnerUserId={resourceOwnerUserId}
            onInputFocus={onInputFocus}
            sceneId={sceneId}
            shotId={shotId}
            hideVisibility={hideVisibility}
            isV2Design={isV2Design}
            hideTimestamp={hideTimestamp}
            metadata={metadata}
            {...commentModalProps}>

            {children || null}
          </CommentPopoverComponent>);

      }}

    </CommentsContext.Consumer>);

}

export default memo(CommentPopover);